import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "col-sm-6" }
const _hoisted_7 = { class: "col-sm-6" }
const _hoisted_8 = { class: "col-sm-6" }
const _hoisted_9 = { class: "col-lg-6" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-xxl-8" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "col-xxl-4" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-md-6 col-xxl-12" }
const _hoisted_18 = { class: "col-md-6 col-xxl-12" }
const _hoisted_19 = { class: "row justify-content-center" }
const _hoisted_20 = { class: "col-md-6 col-xxl-4" }
const _hoisted_21 = { class: "col-md-6 col-xxl-4" }
const _hoisted_22 = { class: "col-md-12 col-xxl-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TotalIncome = _resolveComponent("TotalIncome")!
  const _component_TotalShipment = _resolveComponent("TotalShipment")!
  const _component_TotalCustomer = _resolveComponent("TotalCustomer")!
  const _component_TotalOrder = _resolveComponent("TotalOrder")!
  const _component_ShipmentDeliveredChart = _resolveComponent("ShipmentDeliveredChart")!
  const _component_AverageDeliveryTimeChart = _resolveComponent("AverageDeliveryTimeChart")!
  const _component_LiveShipmentStatusChart = _resolveComponent("LiveShipmentStatusChart")!
  const _component_TrackingOrder = _resolveComponent("TrackingOrder")!
  const _component_ShipmentToTopCountries = _resolveComponent("ShipmentToTopCountries")!
  const _component_ChatContent = _resolveComponent("ChatContent")!
  const _component_TopShippingMethodsChart = _resolveComponent("TopShippingMethodsChart")!
  const _component_TodaysShipmentsChart = _resolveComponent("TodaysShipmentsChart")!
  const _component_OnTimeDeliveryChart = _resolveComponent("OnTimeDeliveryChart")!
  const _component_ShipmentList = _resolveComponent("ShipmentList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_TotalIncome)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_TotalShipment)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_TotalCustomer)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_TotalOrder)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_ShipmentDeliveredChart)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_AverageDeliveryTimeChart)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_LiveShipmentStatusChart)
          ])
        ]),
        _createVNode(_component_TrackingOrder)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_ShipmentToTopCountries)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_ChatContent)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_TopShippingMethodsChart)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_TodaysShipmentsChart)
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createVNode(_component_OnTimeDeliveryChart)
      ])
    ]),
    _createVNode(_component_ShipmentList)
  ]))
}